import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { FaLock } from 'react-icons/fa6';
import './ErrorPage.scss';

/**
 * ShopClosedPage - Displayed by MainLayout in place of the route tree when
 * the shop is closed to the visitor (shop_state `closed`, see useShopState;
 * TopNav above it still carries the shop's name and logo). Only staff can
 * get past this — the login link routes them to the standard login page,
 * which is one of the always-allowed paths.
 */
const ShopClosedPage = () => {
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <div className="error-page-content">
        <div className="error-icon">
          <FaLock size={64} />
        </div>

        <h1 className="error-title">
          {t('shopClosed.title', 'This shop is not open yet')}
        </h1>

        <p className="error-message">
          {t(
            'shopClosed.message',
            'Please check back later.',
          )}
        </p>

        <div className="error-actions">
          <Link className="button is-primary" to="/login">
            {t('shopClosed.login', 'Administrator login')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShopClosedPage;
